import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { HintTypeEnum } from 'projects/workspace/src/app/hrm/models/hints-list.model';
import {
  ProductFormLayoutHints,
} from 'projects/workspace/src/app/products-two-level/products-hints.config';
import {
  BaseMegaHintComponentDependences,
  BaseMegaHintsComponent
} from '../../../rnpl-common/components/base-mega-hints/base-mega-hints.component';

@Component({
  selector: 'rnpl-form-composer-mega-hint',
  templateUrl: './form-composer-mega-hint.component.html',
  styleUrls: ['./form-composer-mega-hint.component.scss']
})
export class FormComposerMegaHintComponent extends BaseMegaHintsComponent implements OnInit, OnChanges {

  @Input() public availableAttributes: boolean;
  @Input() public assignedAttributes: boolean;

  constructor(
    public deps: BaseMegaHintComponentDependences
  ) {
    super(deps);
  }

  ngOnInit() {
    this.endFinishText = 'PRODUCTS.FORM_LAYOUT';
    this.megaHintTimer = 700;
    this.displayHints();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('availableAttributes') || changes.hasOwnProperty('assignedAttributes') ) {
      clearInterval(this.countdownTimer);
      if (this.shepherdService.isActive) {
        this.shepherdService.cancel();
      }

      this.initHints();
    }
  }

  private initHints(): void {
    this.hintsList = [];
    this.notViewedHintsList = [];

    this.hrmService.getHintsByPage(this.screenName)
      .pipe(takeUntil(this._destroy))
      .subscribe(hints => {

        if (!!hints.data.hints && !!hints.data.hints.length) {
          this.hintListByName = ProductFormLayoutHints(this.availableAttributes, this.assignedAttributes);

          this.hintsList = this.prepareHintsList(hints.data.hints)
            .filter(hint => hint.type !== HintTypeEnum.MEGA)
            .filter(hint => !!this.hintListByName[hint.name]);

          this.notViewedHintsList = this.prepareHintsList(hints.data.hints)
            .filter(hint => hint.type !== HintTypeEnum.MEGA)
            .filter(hint => !hint.viewed)
            .filter(hint => !!this.hintListByName[hint.name]);

          this.megaHintId = +hints.data.hints[0].id;

          if (!!this.notViewedHintsList && !!this.notViewedHintsList.length) {
            this.addHintsSteps(this.notViewedHintsList);
          }

          if (!!hints.data.hints && !!hints.data.hints.length && !hints.data.hints[0].viewed && hints.data.hints[0].type === HintTypeEnum.MEGA) {
            this.isCloseHint$.next(false);
            this.startTimerMegaHint();
          } else {
            if (!!this.notViewedHintsList && !!this.notViewedHintsList.length) {
              this.shepherdService.start();
            }
          }
        }
      });
  }

}
